import { SecondaryMenuItemButtonProps, SecondaryMenuItemLinkProps } from './types';

export const isLink = (
  props: SecondaryMenuItemLinkProps | SecondaryMenuItemButtonProps
): props is SecondaryMenuItemLinkProps => 'href' in props;
